"use strict";

define('service/email',['underscore', 'appkit/service'], function (_, Service) {
  var EmailService = Service.extend({
    replies: {
      'convert:emailStringToArray': 'convertEmailsToArray',
      'openEmailInPopup': 'openEmailInPopup',
      'convert:tokensToEmails': 'convertTokensToEmails',
      'convert:emailsToTokens': 'convertEmailsToTokens',
      'convert:peopleToEmails': 'convertPeopleToEmails'
    },
    openEmailInPopup: function openEmailInPopup(options) {
      options = options || {};
      var popup = options.popup;
      if (!popup) {
        popup = this.request('pdf:popup');
      }
      popup.document.body.innerHTML = this.request('imageAbsolutePath', options.content);
      popup.document.title = options.title || "";
    },
    convertTokensToEmails: function convertTokensToEmails(tokens) {
      return tokens.map(function (token) {
        if (token.get('value')) {
          return token.get('value');
        }
        return token.get('text');
      }).join(';');
    },
    convertEmailsToTokens: function convertEmailsToTokens(data) {
      return _.map(this.convertEmailsToArray(data), function (email) {
        var values = this.splitEmailField(email);
        return {
          text: values[0],
          title: values[1],
          value: email
        };
      }, this);
    },
    splitEmailField: function splitEmailField(email) {
      var startIndex = email.indexOf('<'),
        endIndex;
      if (startIndex < 0) {
        return [email];
      }
      endIndex = email.indexOf('>');
      return [email.slice(0, startIndex).trim(), email.slice(startIndex + 1, endIndex)];
    },
    convertPeopleToEmails: function convertPeopleToEmails(people, options) {
      options = options || {};
      var emails = null,
        current = this.convertEmailsToArray(options.current || '');
      if (people instanceof Backbone.Collection) {
        people = people.models;
      }
      emails = _.chain(people).invoke('get', 'primaryEmail').filter(function (email) {
        return !!email;
      }).value();
      return current.concat(emails).join(';');
    },
    convertEmailsToArray: function convertEmailsToArray(data) {
      var emails = _.isString(data) ? data.split(/[;,]+/) : [],
        tokens = [];
      for (var i = 0, numOfEmails = emails.length; i < numOfEmails; i++) {
        if (emails[i]) {
          tokens.push(String(emails[i]).trim());
        }
      }
      return tokens;
    }
  });
  return EmailService;
});

